/**
 * navigation/useActiveView.ts
 * Current app route for the sidebar's active-item highlight, read from the
 * container ref (the sidebar lives outside the navigator). Sub-screens roll up
 * to their parent nav entry, mirroring the old AppContext PARENT map.
 */

import { useEffect, useState } from 'react';
import { navigationRef } from './navigationRef';
import type { AppRouteName } from './types';

const PARENT: Partial<Record<AppRouteName, AppRouteName>> = {
  editor: 'items',
  bundle: 'bundles',
  pricereview: 'bundles',
  site: 'website',
};

export function useActiveView(): AppRouteName {
  const [active, setActive] = useState<AppRouteName>('dashboard');

  useEffect(() => {
    const sync = () => {
      const current = navigationRef.isReady() ? navigationRef.getCurrentRoute() : undefined;
      if (!current) return;
      const name = current.name as AppRouteName;
      setActive(PARENT[name] ?? name);
    };
    sync();
    const unsubscribe = navigationRef.addListener('state', sync);
    return unsubscribe;
  }, []);

  return active;
}
